<template>
  <div id="about">
    <narrowBanner/>

    <br/>
    <section class="hero is-primary">
      <div class="hero-body">
        <div class="container">
          <nav class="breadcrumb is-small" aria-label="breadcrumbs">
            <ul>
              <li><router-link to="/">首頁</router-link></li>
              <li class="is-active"><router-link to="/about" aria-current="page">關於本會</router-link></li>
            </ul>
          </nav>
        </div>
      </div>
    </section>

    <section class="section">
      <div class="container">
        <h2 class="title is-size-4">{{ $prismic.richTextAsPlain(info.heading) }}</h2>
        <br/>
        <div class="columns is-multiline">
          <div class="column is-one-third-tablet is-one-quarter-desktop" v-for="(member, index) in members.slice(0, 8)" :key="'member-' + index">
            <div class="card has-background-white-bis">
              <header class="card-header">
                <p class="card-header-title">{{ $prismic.richTextAsPlain(member.position) }}</p>
                <a v-bind:href="member.link.url" class="card-header-icon" aria-label="more options">
                  <span class="icon">
                    <template v-if="member.link.url">
                      <i class="button fas fa-link has-background-white-bis" aria-hidden="true"></i>
                    </template>
                    <template v-else>
                      <i class="button fas fa-link has-background-white-bis" aria-hidden="true" disabled></i>
                    </template>
                  </span>
                </a>
              </header>
              <div class="card-content">
                <figure class="image is-256x256">
                  <!-- <img class="is-rounded" v-bind:src="member.portrait.url"> -->
                  <prismic-image :field="member.portrait" class="is-rounded"/>
                </figure>
              </div>
              <footer class="card-footer">
                <div class="card-footer-item">
                  <div>
                    <span>{{ $prismic.richTextAsPlain(member.original_name) }}</span><br />
                    <span>{{ $prismic.richTextAsPlain(member.first_and_lastname) }}</span>
                  </div>
                </div>
                <div class="card-footer-item">
                  <span>{{ $prismic.richTextAsPlain(member.major_and_year) }}</span>
                </div>
              </footer>
            </div>
          </div>
        </div>
        <br/>

        <div>
          <!-- <prismic-link :field="info.link" class="button is-link">前任理事</prismic-link> -->
          <prismic-rich-text :field="info.description"/>
        </div>

        <div class="content">
          <div v-for="(item, index) in info.other_information" :key="'item-' + index">
            <hr/>
            <h2 class="title is-size-4">{{ $prismic.richTextAsPlain(item.heading) }}</h2>
            <prismic-rich-text :field="item.content"/>
            <template v-if="item.image.url">
              <figure class="image">
                <prismic-image :field="item.image"/>
              </figure>
            </template>
          </div>
        </div>
      </div>
    </section>

    <br/>
  </div>
</template>

<script>
import narrowBanner from '@/components/narrowBanner.vue';

export default {
  name: 'about',
  components: {
    narrowBanner,
  },
  data() {
    return {
      info: [],
      members: [],
    };
  },
  methods: {
    getContent() {
      this.$prismic.client
        .query(this.$prismic.Predicates.at('document.type', 'about'))
        .then((response) => {
          this.info = response.results[0].data;
          this.members = response.results[0].data.team;
        });
    },
  },
  created() {
    this.getContent();
  },
};
</script>

<style lang="scss" scoped>
.hero-body {
  padding: 0.17rem 1.5rem;
}

.card-header-icon {
  & i {
    border: none;
  }
}

.card-footer {
  display: -webkit-box;
  .card-footer-item {
    flex-basis: auto;
    @media screen and (max-width: 769px) {
      flex-basis: 0;
    }
  }
}
</style>
